// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1tiV7","rootCenter":"LoadMoreObserver_rootCenter__3XS51","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__3BB1E"};